module.exports = __webpack_public_path__ + "static/media/sh.829ef73f.svg";